export const abundanceModel = Object.freeze({
  lowerBoundForAbundanceValue: 0.001
})
